/**
 * [加载更多]
 */
var matchHtmlRegExp = /["'&<>]/;

function escapeHtml(string) {
    var str = '' + string;
    var match = matchHtmlRegExp.exec(str);
    if (!match) {
        return str;
    }
    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;

    for (index = match.index; index < str.length; index++) {
        switch (str.charCodeAt(index)) {
            case 34: // "
                escape = '&quot;';
                break;
            case 38: // &
                escape = '&amp;';
                break;
            case 39: // '
                escape = '&#39;';
                break;
            case 60: // <
                escape = '&lt;';
                break;
            case 62: // >
                escape = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) {
            html += str.substring(lastIndex, index);
        }
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

var tpl = '' +
    '<li>' +
    '<a href="{{url}}" target="_blank" class="con">' +
    '<span class="type">{{type}}</span>' +
    '<strong class="tit">{{title}}</strong>' +
    '<strong class="tit-sub">{{subTitle}}</strong>' +
    '<img src="{{img}}" alt="" width="365" height="475" />' +
    '<b class="line"></b>' +
    '</a>' +
    '</li>';

function render(data) {
    var html = '';
    $.each(data, function(i, item) {
        html += tpl.replace(/\{\{(\w+)\}\}/img, function(w, key) {
            return escapeHtml(item[key]);
        });
    });
    $('.focus-list').html(html);
    new ue.Focus($('.focus'));
}

$.ajax({
    url: 'http://interface.17173.com/focus/indexList_2018.jsonp',
    data: {
        url: 'http://www.17173.com/2018/focus/inc-focus.shtml'
    },
    dataType: 'jsonp'
}).done(function(data) {
    render(data.data);
});

//对游戏进行缓存
var gameInfoCache = {};

function getGameCode($dom) {
    var code = $dom.data('gamecodes') || '';
    code = (code + '').split(',');
    return code.pop();
}

function getGameInfo($el) {
    var cache = {};
    var codes = [];
    var $gamecodes = $el.find('[data-gamecodes]');
    $gamecodes.each(function() {
        var target = $(this);
        var gamecode = getGameCode(target);
        if (!gameInfoCache[gamecode] && !cache[gamecode] && gamecode) {
            codes.push(gamecode);
            cache[gamecode] = true;
        }
    });
    getGameData(codes, function(data) {
        $.each(data, function(i, item) {
            gameInfoCache[item.gameCode] = item;
        });
        $gamecodes.each(function() {
            var target = $(this);
            var code = getGameCode(target);
            if (code) {
                target.html(renderGameTag(gameInfoCache[code]));
            }
        });
    });
}

function getGameData(codes, callback) {
    if (!codes || codes.length < 1) {
        callback([]);
        return;
    }
    $.ajax({
        url: '//interface.17173.com/game/infoByCode.jsonp',
        data: {
            gameCodes: codes.join(',')
        },
        dataType: 'jsonp'
    }).done(function(data) {
        callback(data.data);
    });
}
var nameMap = {
    channelUrl: '专区',
    downloadUrl: '下载',
    gameOfficialUrl: '官网',
    giftList: '礼包'
};

function renderGameTag(item) {
    var html = '';
    var url;
    for (var key in item) {
        if (nameMap[key] && item[key]) {
            url = Object.prototype.toString.call(item[key]) == '[object Array]' ? item[key][0].giftUrl : item[key];
            html += '<a href="' + escapeHtml(url) + '" target="_blank" class="tag"> ' + nameMap[key] + ' </a>';
        }
    }
    return html;
}
pandora.use(['loadlist', 'thumb'], function(LoadList, Thumb) {
    var mainList = $('#mainList');
    var contentKeys = {};

    mainList.find('[data-key]').each(function() {
        var key = $(this).data('key');
        contentKeys[key] = key;
    });

    var list = new LoadList({
        element: mainList,
        categoryIds: mainList.data('ids'),
        pageNo: 3,
        autoLoad: false
    });

    var thumb = new Thumb({
        element: mainList,
        selecter: '.avatar img'
    });

    list.on('load', function(e, res) {
        var key, data = res.data;
        for (var i = data.length - 1; i >= 0; i--) {
            key = data[i].contentKey;
            if (contentKeys[key]) {
                data.splice(i, 1);
            } else {
                contentKeys[key] = key;
            }
        }
        if (data.length < 5) {
            list.nextPage();
        }
    });

    list.on('listRender', function(e, $html) {
        getGameInfo($html);
        thumb.handle($html);
    });

});
getGameInfo($('#mainList'));


//////////////////
// WEBPACK FOOTER
// ./src/component/morenews.js
// module id = 4
// module chunks = 0